import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/depop-verified-badge';

export default function Example() {
  return (
    <>
      <Head>
        <title>Depop Badge: How To Get Verified By Becoming a Top Seller on the App</title>
        <meta
          name='description'
          content='Similar to other social media sites, getting that blue tick beside your username feels like a badge–and indeed it is–for sellers, celebrities, and figures on Depop. But what exactly does this mean?'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/depop-verified-badge' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/depop-verified-badge' />
        <meta property='og:title' content='Depop Badge: How To Get Verified By Becoming a Top Seller on the App' />
        <meta
          property='og:description'
          content='Similar to other social media sites, getting that blue tick beside your username feels like a badge–and indeed it is–for sellers, celebrities, and figures on Depop. But what exactly does this mean?'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-06-12T00:00:00-00:00' />
        <meta property='article:tag' content='Depop' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
